<template>
  <div>

    <validation-observer ref="form">
      <b-form @submit.prevent="save">
        <div class="vx-row mt-4">
          <div class="vx-col sm:w-1/5 w-full mb-2">

            <b-form-group
              label="Tipo"
              label-for="account_type"
            >
              <validation-provider
                #default="{ errors }"
                name="account_type"
                rules="required"
              >
                <v-select v-model="phoneType" :options="phoneTypeList" label="name" class="required-select">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

          <div class="vx-col sm:w-1/5 w-full mb-2">

            <b-form-group
              label="DDD"
              label-for="area_code"
            >
              <validation-provider
                #default="{ errors }"
                name="area_code"
                rules="required"
              >
                <v-select v-model="areaCode" :options="areaCodeList" label="code" class="required-select">
                  <div slot="no-options">Nenhum registro encontrado!</div>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

          <div class="vx-col sm:w-1/4 w-full mb-2">

            <b-form-group
              label="Telefone"
              label-for="number"
            >
              <validation-provider
                #default="{ errors }"
                name="number"
                rules="required"
              >
                <b-form-input
                  id="number"
                  v-model="number"
                  :state="errors.length > 0 ? false:null"
                  name="number"
                  v-mask="['####-####', '#####-####']"
                  class="required"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </div>

          <div class="vx-col sm:w-1/4 w-full mb-2">
            <b-form-checkbox v-model="head" class="mt-6 float-right">Telefone principal</b-form-checkbox>
          </div>
        </div>

        <div class="vx-row mt-2">
          <div class="vx-col w-full">

            <b-button
              v-if="editMode"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              @click="cancelEdit"
              class="float-right"
            >
              Cancelar
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              type="submit"
              :class="['float-right', {'mr-2': editMode}]"
              :disabled="!validateForm"
            >
              {{this.editMode ? 'Alterar' : 'Adicionar'}}
            </b-button>

          </div>
        </div>
      </b-form>
    </validation-observer>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="phoneList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Tipo</vs-th>
            <vs-th>DDD</vs-th>
            <vs-th>Número</vs-th>
            <vs-th>Principal</vs-th>
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].phone_type.name}}</vs-td>
              <vs-td>{{data[indextr].area_code.code}}</vs-td>
              <vs-td>{{data[indextr].number}}</vs-td>
              <vs-td>
                <span v-if="data[indextr].pivot.head">Sim</span>
                <span v-else>Não</span>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  title="Editar"
                  style="cursor: pointer;"
                  class="h-5 w-5 mb-1 mr-3 stroke-current text-warning"
                  @click="edit(data[indextr])"
                />
                <feather-icon
                  icon="Trash2Icon"
                  style="cursor: pointer;"
                  class="h-5 w-5 mb-1 mr-3 stroke-current text-danger"
                  @click="destroy(data[indextr])"
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'

import vSelect from 'vue-select'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    services: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    id: null,
    parentEntity: null,
    phoneType: null,
    areaCode: null,
    number: null,
    head: false,
    phoneTypeList: [],
    areaCodeList: [],
    phoneList: [],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {
    validateForm() {
      return (
        // !this.errors.any() && //vee-validate-fix
        this.phoneType !== null &&
        !this.isEmpty(this.areaCode) &&
        !this.isEmpty(this.number)
      )
    }
  },
  watch: {},
  methods: {
    save() {

      this.$refs.form.validate().then(success => {
        if (success) {

          this.clearErrors(this.$refs.form)
          this.$vs.loading()

          const params = {
            people_id: this.parentEntity.people.id,
            phone_type_id: this.phoneType.id,
            area_code_id: this.areaCode.id,
            number: this.number,
            head: !!this.head
          }

          if (this.editMode) {
            params['id'] = this.id
          }

          this.services.phoneService.createOrUpdate(params).then(
            data => {
              this.$vs.loading.close()
              this.phoneList = data.phones
              this.editMode = false
              this.clearFields()
              this.notifySuccess(this.$vs)
            },
            error => {
              this.$vs.loading.close()
              this.showErrors(this.$refs.form, error)
            }
          )
        }
      })
    },
    destroy(phone) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(phone)
        }
      })
    },
    acceptDestroy(phone) {
      this.$vs.loading()
      this.services.phoneService
        .destroy({
          id: phone.id
        })
        .then(
          data => {
            this.$vs.loading.close()
            this.phoneList = this.phoneList.filter(element => {
              return element.id !== phone.id
            })

            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    edit(phone) {
      this.id = phone.id
      this.editMode = true
      this.phoneType = phone.phone_type
      this.areaCode = phone.area_code
      this.number = phone.number
      this.head = phone.pivot.head
    },
    cancelEdit() {
      this.editMode = false
      this.clearFields()
    },
    clearFields() {
      this.phoneType = null
      this.areaCode = null
      this.number = null
      this.head = false
    },
    phoneQuantity() {
      return this.phoneList.length
    },
    loadEntity(entity) {
      this.parentEntity = entity
      this.phoneList = Array.from(entity.people.phones)
    }
  },
  beforeMount() {
    this.$vs.loading()

    const promisses = []
    promisses.push(
      this.services.phoneTypeService.all().then(
        data => {
          this.phoneTypeList = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )

    promisses.push(
      this.services.areaCodeService.all().then(
        data => {
          this.areaCodeList = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })
  },
  beforeDestroy() {
    this.$root.$off('natural-entity:loaded', this.loadEntity)
  },
  mounted() {
    this.$root.$on('naturalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['naturalEntity/naturalEntity']
      this.phoneList = Array.from(this.parentEntity.people.phones)
    })

    this.$root.$on('legalEntityUpdated', () => {
      this.parentEntity = this.$store.getters['legalEntity/legalEntity']
      this.phoneList = Array.from(this.parentEntity.people.phones)
    })

    this.$root.$on('legalEntityCreated', (legalEntity) => {
      this.parentEntity = legalEntity
      if (this.parentEntity.people) {
        this.addressList = Array.from(this.parentEntity.people.addresses)
      }
    })

    this.$root.$on('naturalEntityCreated', (naturalEntity) => {
      this.parentEntity = naturalEntity
    })

    this.$root.$on('natural-entity:loaded', this.loadEntity)
  }
}
</script>
